import { useMutation, useQueryClient } from '@tanstack/react-query';
import API from 'api/API';
import { QueryKeys } from 'api/models/QueryKeys';

export const useReturnOrder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (...args: Parameters<typeof API.orders.returnOrder>) => API.orders.returnOrder(...args),
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries([QueryKeys.Delivery]),
        queryClient.invalidateQueries([QueryKeys.Deliveries]),
        queryClient.invalidateQueries([QueryKeys.TimeStamps]),
        queryClient.invalidateQueries([QueryKeys.Order]),
        queryClient.invalidateQueries([QueryKeys.Orders]),
        queryClient.invalidateQueries([QueryKeys.SurgeryTimeStamps]),
      ]),
  });
};
